<template>
  <Select v-model="model" clearable @on-change="onChange" transfer>
    <Option v-for="item in activityList" :value="item.id" :key="item.id">{{ item.id + ' - ' + item.firstName+ item.lastName }}</Option>
  </Select>
</template>
<script>
  export default {
    name: 'ActivitySelect',
    props: {
      value: {
        type: [Number, String],
      },
      openedId: {
        type: [Number],
        default: null
      },
      dataL: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        activityList: [],
        model: ''
      }
    },
    methods: {
      onChange (value) {
        console.log(`value`, value)
        this.$emit('input', value)
      },
    },
    mounted: function () {
    },
    watch: {
      value (val) {
        if (val) {
          let idNumber = parseInt(val)
          this.model = idNumber
        } else {
          this.model = ''
        }
      },
      dataL(val){
        this.activityList = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SubstituteTchSelect.vue?2c4bcbf3